import React from 'react';
import '../Section10/component.css';

const Section11 = () => {
  return (
    <div className="svc-intro" style={{ paddingTop: '0px', borderBottom: 'none' }}>
      <div className="svc-intro-inner">
        <div className="svc-details">
          <h3 className="svc-intro-title">Why Choose Hypertonic</h3>

          <div className="svc-feature">
            <h4>Expertise</h4>
            <p className="svc-intro-body">Our team comprises seasoned professionals with extensive experience in website development. From frontend design to backend programming, we have the expertise to bring your vision to life and deliver exceptional results.</p>
          </div>

          <div className="svc-feature">
            <h4>Fully Responsive</h4>
            <p className="svc-intro-body">With our responsive design, your website effortlessly adjusts to all screen sizes, ensuring seamless access for new clients on mobile phones, tablets, and desktop computers.</p>
          </div>

          <div className="svc-feature">
            <h4>Free Hosting</h4>
            <p className="svc-intro-body">At Hypertonic, we believe in making web hosting accessible to everyone. That's why we're excited to offer you our free hosting service, designed to provide you with a reliable platform to launch your website.</p>
          </div>

          <div className="svc-feature">
            <h4>Free Maintenance</h4>
            <p className="svc-intro-body">We're excited to offer you our free maintenance service, designed to keep your website running smoothly without any additional fees.</p>
          </div>

          <div className="svc-feature">
            <h4>24*7 Service</h4>
            <p className="svc-intro-body">Whether it's the middle of the night or a holiday weekend, our team is here for you 24 hours a day, 7 days a week. You can count on us to be there when you need assistance most.</p>
          </div>

          <div className="svc-feature">
            <h4>Custom Solutions</h4>
            <p className="svc-intro-body">We believe in tailor-made solutions that cater to the unique needs and objectives of each client. Whether you're a startup or a large corporation, we deliver custom solutions that exceed expectations.</p>
          </div>

          <div className="svc-feature">
            <h4>Cutting-Edge Tech</h4>
            <p className="svc-intro-body">We leverage cutting-edge technologies from responsive design to interactive user interfaces to create websites that are visually stunning and highly functional.</p>
          </div>

          <div className="svc-feature">
            <h4>Scalability & Flexibility</h4>
            <p className="svc-intro-body">We understand that businesses evolve, and so should websites. We design with scalability and flexibility in mind, allowing for easy updates and modifications as your business grows.</p>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Section11;
